<template>
  <div class="myReserve">
		<div v-show="!dialogVisible">
			<div class="search">
				<el-select v-model="state" placeholder="请选择" @change="getList" style="margin-right: 15px;">
					<el-option label="全部类型" value="-1"></el-option>
					<el-option label="申请中" value="0"></el-option>
					<el-option label="成功" value="1"></el-option>
					<el-option label="失败" value="2"></el-option>
				</el-select>
				<el-button type="success" @click="addApply">新 增</el-button>
			</div>
			<div class="table">
			  <el-table :data="tableData" height="700px"  v-loading="loading" element-loading-text="数据加载中..." align="center" :header-cell-style="{background:'#f4f7fe'}">
					 <el-table-column prop="name" label="项目名" ></el-table-column>
					 <el-table-column prop="userName" label="采伐者" width="150"></el-table-column>
					 <el-table-column prop="nodeName" label="当前节点" width="150">
						 <template slot-scope="scope">
						 	<el-button @click="rowDetail(scope.row,3)" type="text" size="small">{{scope.row.nodeName}}</el-button>
						 </template>
					 </el-table-column>
					 <!-- <el-table-column prop="stateName" label="状态" width="150"></el-table-column> -->
					 <el-table-column prop="creationTimeStr" label="时间" width="200"></el-table-column>
			    <el-table-column label="操作" width="200" align="right">
			      <template slot-scope="scope">
							<el-button @click="materialsDialogVisible=true;rowID=scope.row.id;illustrate=scope.row.illustrate" type="text" size="small" v-if="scope.row.showType==2">补充材料</el-button>
							<el-button @click="rowDetail(scope.row,1)" v-if="scope.row.idType==3" type="text" size="small">详情</el-button>
							<el-button @click="rowDetail(scope.row,2)" v-if="scope.row.idType==4" type="text" size="small">详情</el-button>
			      </template>
			    </el-table-column>
			  </el-table>
			</div>
			<div class="page">
				<el-pagination
				      @size-change="handleSizeChange"
				      @current-change="handleCurrentChange"
				      :current-page.sync="currentPage"
				      :page-sizes="[10, 20, 50]"
				      layout="sizes, prev, pager, next"
				      :total="total">	
				    </el-pagination>
			</div>
		</div>
		<!-- 补充材料 -->
		<el-dialog
		  title="补充材料"
		  :visible.sync="materialsDialogVisible"
		  width="30%"
		  :before-close="handleClose">
		  <el-form ref="form" label-width="120px">
				<el-form-item label="说明：">{{illustrate}}</el-form-item>
				<el-form-item label="资料附件文件："  style="flex: 1;">
					<el-upload
						class="upload-demo"
						accept=".zip,.rar"
						action="#"
						:limit="1"
						:on-change="(file) => {handleChange(file)}"
						:on-remove="(file) => {handleRemove(file)}"
						:auto-upload="false"
						:file-list="files"
					>
						<el-button size="small" type="success">点击上传</el-button>
					</el-upload>
				</el-form-item>
			</el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="handleClose">取 消</el-button>
		    <el-button type="success" @click="supplement">确 定</el-button>
		  </span>
		</el-dialog>
		<!-- 步骤条 -->
		<el-drawer
		  title="审批详情"
		  :visible.sync="detailModal"
			:modal="false"
			 size="20%"
		  >
			<el-scrollbar style="height: 95%" ref="scrollbar">
				 <el-steps finish-status="success" direction="vertical" :active="currentINdex" :space="80">
				    <el-step  :title="item.nodeName" v-for="(item,index) in stepList" :key="index"></el-step>
				 </el-steps>
			</el-scrollbar>
		</el-drawer>
		<!-- 添加/编辑 -->
		<Dialog
			ref="addFellLicence"
			:currentType="currentType"
			@close-dialog="dialogVisible = $event"
			@dialog-add-confirm="handleConfirm"
			@approve-confirm="handleConfirm"
			v-show="dialogVisible"
		/>
    <iframe id="iframe" ref="iframe" :frameborder="0" src="https://lyapp.gispai.com/dataDoc" v-show="false"></iframe>
  </div>
</template>

<script>
import { GetMyapplysFormPhone,PerfectDicLicense } from "@/api/approveManage";
import { GetFlowcharInfo} from "@/api/Flowchart";
import Dialog from "./components/fellLicenceOperate.vue"
import { baseUrl2 } from '@/static/utils/lyconfig';
import request from '@/utils/axios';
import { GetMyMapToken2 } from '@/api/user';
export default {
  name: "autonymAudit",
  components: {
    Dialog
  },
  data() {
    return {
			state:'-1',
      loading: false, // 数据是否处于加载状态
      tableData: [], // 表格数据
      total: 0, // 数据总数
      currentPage: 1, // 当前页数
      pageSize: 10, // 当前查询数据个数
      dialogVisible: false, // 新增对话框是否显示
			currentType: 'add',
			materialsDialogVisible:false,
			files:[],
			rowID:null,
			stepList:[],//步骤条列表
			currentINdex:null,
			detailModal:false,//步骤条详情
			illustrate:"",//补充材料的说明
    };
  },
	computed:{
		user() {
			return this.$store.state.user;
		},
	},
  async mounted() {
		this.$nextTick(()=>{
			let token = JSON.parse(localStorage.getItem('user-token-gispai'))
			GetMyMapToken2(token).then(res=>{
				if(res.data.state>0){
					const iframeWin = this.$refs['iframe'].contentWindow
					let user_gispai = JSON.parse(JSON.parse(localStorage.getItem("user_gispai")))
					if(res.data.state==2){
						localStorage.setItem('user-token-gispai', JSON.stringify(res.data.data));
						user_gispai.Token = res.data.data
						localStorage.setItem('user_gispai',JSON.stringify(JSON.stringify(user_gispai)))
					}
					 document.getElementById("iframe").onload=()=>{
					   iframeWin.postMessage({user:JSON.stringify(user_gispai)},'*')
					};
				}
			})
			this.getList();
		})
    
  },
  methods: {
		// 分页查询
		handleSizeChange(e){
			this.pageSize = e
			this.getList()
		},
		handleCurrentChange(e){
			this.currentPage = e
			this.getList()
		},
    /*获取所有数据列表 */
    async getList() {
			this.loading = true
      try {
        let params = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
          state: this.state,
					keyword:'',
          type: '2',
        };
        let { data } = await GetMyapplysFormPhone(params);
        if(data.state === 1) {
          this.tableData = data.data.lis
          this.total = data.data.count
					this.loading = false
        }else {
					this.loading = false
				}
      } catch (err) {
      }
    },
		handleClose(){
			this.materialsDialogVisible = false;
			this.rowID=null;
			this.files=[]
		},
		// 补充材料
		async supplement(){
			const that = this
			if(that.files.length==0){
				return that.$message.warning('请上传材料')
			}
			let files = []
			let formData = new FormData();
			formData.append('files', that.files[0].raw);
			 await request({
			    method: 'post',
			    url: baseUrl2 + '/api/Ordered/UploadFiles2',
			    headers: { 'Content-Type': 'multipart/form-data', token: that.$store.state.user.Token },
			    data: formData
			   }).then(res => {
			    if (res.status == 200) {
			     if (res.data.state == 1) {
			        files =  JSON.parse(res.data.data)
			     } else {
						return false
			     }
			    } else {
			        return false
			    }
			   })
				 PerfectDicLicense({id:that.rowID,files:JSON.stringify(files)}).then(res=>{
					 if(res.data.state == 1){
					 	that.$message.success('操作成功')
						that.handleClose()
						that.getList()
					 }else{
					 	that.$message.error(res.data.msg)
					 }
				 })
				 
		},
		// 添加预约
		addApply() {
			this.currentType = 'add';
			this.dialogVisible = true;
			this.$refs.addFellLicence.getFlowChartSelectionBox();
			this.$refs.addFellLicence.getZhen();
		},
		handleConfirm() {
			this.dialogVisible = false;
			this.getList();
		},
    /* 数据详情 */
    rowDetail(row,type) {
			this.currentType = 'detail';
			if(type==1){
				this.$refs.addFellLicence.getApproveDetail(row.id)
				this.dialogVisible = true;
			}else if(type==2){
				this.$refs.addFellLicence.getOrderDetail(row.id)
				this.dialogVisible = true;
			}else{
				GetFlowcharInfo({id:row.id,idType:row.idType}).then(res=>{
					if(res.data.state==1){
						this.stepList = res.data.data.list
						this.currentINdex = res.data.data.selectIndex
					}
				})
				this.detailModal = true
			}
			
    },
		handleChange(file, type){
			var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1)
			const extension2 = testmsg === "zip";
			const extension3 = testmsg === "rar";
			if (!extension2 && !extension3) {
			  this.$message.warning("请上传zip或rar类型文件!")
				this.files = []
			}else{
				this.files.push({name:file.name,raw:file.raw});
			}
		},
		handleRemove(file){
			this.files = [];
		},
    /* 通过ID删除单行数据 */
    deleteRowData(row) {
			this.$confirm('确定删除？', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
			  DeletelicenceApprove({id:row.Id}).then(res=>{
			  	if(res.data.state==1){
			  		this.$message.success('操作成功')
			  		this.getList()
			  	}else{
						this.$message.erroe(res.data.Msg)
					}
			  })
			}).catch(()=>{})
    },
  }
};
</script>
<style lang="less" scoped>
.myReserve {
  height: 100%;
 .search {
    padding: 15px 30px; 
		display: flex;
		align-items: center;
		justify-content: space-between;
  }
  .table {
    padding: 0px 30px 0px 30px;
  }
  .page {
    text-align: center;
  }
  /deep/ .el-dialog__header {
    padding: 10px;
    background-color: #5bacf0;
  }
  /deep/ .el-dialog__title {
    color: #fff;
  }
  /deep/ .el-dialog__body {
    padding: 15px;
  }
  /deep/ .el-dialog__footer {
    padding: 0px 10px 10px 10px;
  }
	/deep/ .el-drawer {
		top: 60px !important;
		height: 92%!important;
	}
}
.avatar {
	width: 100px;
	height: 100px;
	margin-right: 10px;
}
</style>
